@if (src) {
  <img [height]="height()" [width]="width()" [attr.src]="src" class="figure-img img-fluid rounded" alt="" />
}
